'use strict';
import ShippingAddressListController from './shipping-address-list.controller';
import ShippingAddressListService from './shipping-address-list.service';
import ShippingAddressForm from '../forms/account/shipping-address';
import ngMaterial from 'angular-material';
import dialog from '../dialog';
import tooltip from '../tooltip';
import paging from '../paging';
export default angular.module('directives.shippingAddressList', [ShippingAddressForm, ngMaterial, dialog, tooltip, paging])
    .service('ShippingAddressListService', ShippingAddressListService)
    .component('shippingAddressList', {
    template: require('./shipping-address-list.html'),
    controller: ShippingAddressListController
})
    .filter('zipcode', function () {
    return function (input) {
        if (!input) {
            return input;
        }
        if (input.toString().length === 9) {
            return input.toString().slice(0, 5) + "-" + input.toString().slice(5);
        }
        else if (input.toString().length === 5) {
            return input.toString();
        }
        else {
            return input;
        }
    };
})
    .name;
//# sourceMappingURL=index.js.map